import { CircularProgress, Select } from "@mui/material";
import React, { FC, useEffect, useState } from "react";

import FloatingInputLabel from "../components/FloatingInputLabel";

export interface IDropDownListItem {
    name: string;
    value?: string;
}

const DropDownField: React.FunctionComponent<{
    label: string,
    selectedItem: IDropDownListItem | null;
    onRequestData: () => Promise<IDropDownListItem[]>;
    onChange: (value: IDropDownListItem) => void;
    minWidth?: number | string | undefined;
    maxWidth?: number | string | undefined;
    readOnly?: boolean;
    testId?: string;
}> = (props) => {
    const [items, setItems] = useState<IDropDownListItem[]>([]);

    const selectedItem = props.selectedItem == null ? null : items.filter((cp) => {
        return cp.value == props.selectedItem?.value;
    })[0];

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (props.onRequestData) {
                setLoading(true);
                try {
                    const fetchItems = await props.onRequestData();
                    if (cancelled == false) {
                        setItems(fetchItems);
                    }
                } catch (ex) {
                    if (cancelled == false) {
                        setItems([]);
                    }
                }
                setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        }
    }, [props.label]);

    if (loading == true) {
        return <CircularProgress sx={{ color: (theme) => theme.palette.brand.main }}></CircularProgress>
    }
    return <SimpleDropDownField
        label={props.label}
        value={selectedItem?.value ?? ""}
        items={items}
        onChange={props.onChange}
        minWidth={props.minWidth}
        maxWidth={props.maxWidth}
        readOnly={props.readOnly}
        testId={props.testId}
    />

}

interface SimpleDropDownFieldProps {
    label: string;
    value: string;
    items: IDropDownListItem[];
    onChange: (value: IDropDownListItem) => void;
    minWidth?: number | string | undefined;
    maxWidth?: number | string | undefined;
    readOnly?: boolean;
    testId?: string;
}

export const SimpleDropDownField: FC<SimpleDropDownFieldProps> =
    ({ label, value, items, onChange, minWidth, maxWidth, readOnly, testId }) => {
        const selectedItem = items.find((item) => item.value == value);

        return <FloatingInputLabel label={label} maxWidth={maxWidth}>
            <Select
                data-testid={testId}
                native
                style={{ width: "100%", maxWidth: maxWidth || 225, minWidth: minWidth, borderRadius: 5, padding: 3 }}
                disabled={Boolean(readOnly)}
                value={selectedItem?.value ?? ""}
                onChange={(e) => {
                    const newSelectedItem = items.find((item) => item.value == e.target.value);

                    if (newSelectedItem) {
                        onChange(newSelectedItem);
                    }
                }}
            >
                {(items || []).map((item) => (
                    <option key={item.value} value={item.value}>{item.name}</option>
                ))}
            </Select>
        </FloatingInputLabel>
    }

export default DropDownField;
